export const GEOCODE_API_KEY = 'AIzaSyBrsE08IOCRGRP1epZSub1DyLJpJOeQswY';
export const API_BASE_URL = 'https://phoenix.localbuzz.co/wp-json/wp/v2';
export const TILE_URL =
  'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYnJlbmRhbnRub3JyaXMiLCJhIjoiY2pjcXczYWNwMDNhMzJ3cXo4ZWx0eXVyeCJ9.3PzuLnnJSXgUg1Rq-5Gbug';
